import { Rc } from 'generated/graphql';

export const getSelectedReasonDefinitions = (definitions: Rc[] | undefined) => {
  if (!definitions) {
    return [];
  }

  return definitions.filter((definition) => {
    if (definition.__typename === 'UnassignedRC') {
      return definition.isSelected;
    }
    return true;
  });
};
